import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from "@mui/material/Grid";
import IconButton from '@mui/material/IconButton';
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SimilarProfilesList from "../../sharedComponents/SimilarProfilesList/SimilarProfilesList";
import NewsFeedList from "../../sharedComponents/NewsFeedList/NewsFeedList";
import { makeStyles } from '@mui/styles';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { AdminCoachProfileContext } from "../../common/AdminCoachProfileContext";
import AppConstants from '../../common/AppConstants';
import { AppDataContext } from "../../common/AppContext";
import RouteConstants from "../../common/RouteConstants";
import { Role } from '../../helper';
import ProfileDetails from '../../screens/coachProfile/ProfileDetails';
import { userService } from "../../services";
import AdminService from "../../services/admin.service";
import RejectDialog from "../../sharedComponents/dialog/RejectDialog";
import ProfileSummary from "../../sharedComponents/profileSummary/ProfileSummary";
import { useCoachProfileDialog } from "../CoachesManagement/CoachProfileDialogContext";
import useTelemetry from '../../utils/useTelemetry';
import clsx from 'clsx';
import { darkenColor } from '../../utils/appHelper';
import FeatureArticleNewsContent from '../../sharedComponents/FeatureArticleNewsContent/FeatureArticleNewsContent';

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    dialogPaper: {
        minHeight: '80vh',
        maxHeight: '80vh',
    },
});

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
    },
    grid: {
        display: "flex",
        flexGrow: 1,
        flexWrap: "wrap",
        paddingTop: theme.spacing(1),
        [theme.breakpoints.up("sm")]: {
            padding: theme.spacing(1),
        },
        [theme.breakpoints.down("xs")]: {
            padding: 0,
        },
    },
    section: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
        textAlign: "left",
        padding: "5px 25px",
    },
    gridItem: {
        [theme.breakpoints.up("sm")]: {
            padding: theme.spacing(1),
        },
        [theme.breakpoints.down("xs")]: {
            width: "100%",
            paddingBottom: theme.spacing(2),
        },
    },
    profileSummary: {
        // paddingBottom: theme.spacing(2),
        minHeight: "300px",
        boxShadow: '0px 0px 5px rgba(6, 37, 91, .2)',
        borderRadius: '0',
        backgroundColor: theme.palette.mode === 'dark' ? darkenColor(theme.palette.background.default, 25) : theme.palette.primary.dark
    },
    profileDetails: {
        textAlign: "left",
        color: theme.palette.text.secondary,
    },
}));



function CoachProfileView(props) {

    const classes = useStyles();
    const navigate = useNavigate();
    const dialogCtx = useCoachProfileDialog();

    const {
        fullName,
        roleAndCoachingPhilosophy,
        profilePhoto,
        profileVideo,
        mediaAndArticle,
        coachingVideos,
        coachingExperience,
        other,
        additionalExperience,
        skillSet,
        educationDetail,
        coachingAndOtherJobExperience,
        playingExperience,
        userName,
        retrieveAndSetProfileContext,
        status,
        profileVideos,
        lastModifiedAt,
        jwtTokenDetails,
        profile
    } = useContext(AdminCoachProfileContext);

    const { getLeagueTextByValue } = useContext(AppDataContext);
    const [data, setData] = useState(props.data && props.data ? props.data : []);
    const [personalDetails, setPersonalDetails] = useState(props.data && props.data.personalDetails ? props.data.personalDetails : []);
    const [showApprove, setShowApprove] = useState(false);
    const [showReject, setShowReject] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [openRejectDialog, setOpenRejectDialog] = useState(false);
    const [role, setRole] = useState("");
    const [videoData, setVideoData] = React.useState({});
    const { trackCustomEvents } = useTelemetry();


    useEffect(() => {
        setRole(userService.getUserRole());
    }, [])


    function btnRejectClick(note, sendMail) {
        setOpenRejectDialog(false);
        handleProfileStatusChange(props.params, AppConstants.PROFILE_STATUS.DENIED, note, sendMail)
        setShowApprove(true)
        setShowReject(false)
    }

    function handleApproveClick() {
        if (showApprove) {
            handleProfileStatusChange(props.params, AppConstants.PROFILE_STATUS.APPROVED)
            setShowApprove(false)
            setShowReject(true)
        }
        trackCustomEvents("EditEvent", { action: "Approve" });
    }

    const handleProfileStatusChange = (userName, status, note, sendMail) => {
        let postData = { status: status, profileUserName: userName, reason: note, sendEmail: sendMail };
        setIsLoading(true);
        AdminService.changeProfileStatus(postData).then((data) => {
            // setFilterProfile([]);
            setIsLoading(false);
            // updateStatusProfile(data, 1);
        });
    };

    useEffect(() => {
        retrieveAndSetProfileContext(props.params);
    }, [props.params])

    useEffect(() => {
        getShowApprove();
        getShowReject();
    }, [status])

    const handleEditProfileClick = () => {
        const path = RouteConstants.ADMIN_COACH_PROFILE_EDIT + "/" + props.params;
        if (dialogCtx && dialogCtx.dialogNavigate) {
            dialogCtx.dialogNavigate(path);
        } else {
            navigate(path);
        }
        trackCustomEvents("EditEvent", { action: "Edit Profile" });
    }

    const handleBackClick = () => {
        if (dialogCtx && dialogCtx.dialogBack && dialogCtx.canGoBack) {
            dialogCtx.dialogBack();
        } else if (dialogCtx && dialogCtx.close) {
            dialogCtx.close();
        } else {
            navigate(-1);
        }
        trackCustomEvents("ClickEvent", { action: "Back from Coach Profile" });
    }


    function getShowApprove() {
        if (status.toLowerCase() === AppConstants.PROFILE_STATUS.SUBMITTED ||
            status.toLowerCase() === AppConstants.PROFILE_STATUS.DENIED ||
            status.toLowerCase() === AppConstants.PROFILE_STATUS.RESUBMITTED) {
            setShowApprove(true);
        } else {
            setShowApprove(false);
        }
    }

    function getShowReject() {
        if (status.toLowerCase() === AppConstants.PROFILE_STATUS.SUBMITTED ||
            status.toLowerCase() === AppConstants.PROFILE_STATUS.APPROVED ||
            status.toLowerCase() === AppConstants.PROFILE_STATUS.RESUBMITTED) {
            setShowReject(true);
        } else {
            setShowReject(false);
        }
    }

    //const [profileCompleteness, setProfileCompleteness] = useState(0);
    useEffect(() => {
        setData(props.data ? props.data : []);
        setPersonalDetails(props.data && props.data.personalDetails ? props.data.personalDetails : []);
    }, [props.data])


    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                backgroundColor: (theme) => theme.palette.mode === 'dark' ? darkenColor(theme.palette.background.default, 40) : undefined,
            }}
        >
            <Grid container className={classes.grid}>
                <Grid size={{ xs: 12, sm: 2.5, md: 2.5 }} className={classes.gridItem}>
                    <Paper className={clsx(classes.profileSummary, "custom-view")} sx={{ position: 'relative' }}>
                        <IconButton
                            onClick={handleBackClick}
                            aria-label="back"
                            sx={{
                                position: 'absolute',
                                top: 10,
                                left: 10,
                                zIndex: 2,
                                width: 44,
                                height: 44,
                                color: '#ffffff',
                                backgroundColor: 'rgba(255,255,255,0.25)',
                                border: '1px solid rgba(255,255,255,0.6)',
                                boxShadow: '0px 2px 6px rgba(0,0,0,0.35)',
                                '&:hover': {
                                    backgroundColor: 'rgba(255,255,255,0.4)',
                                },
                            }}
                        >
                            <ArrowBackIcon sx={{ color: '#ffffff', fontSize: 26 }} />
                        </IconButton>
                        <ProfileSummary
                            profilePhoto={profilePhoto}
                            profileVideos={profileVideos}
                            fullName={fullName}
                            userName={userName}
                            roleAndCoachingPhilosophy={roleAndCoachingPhilosophy}
                            mediaAndArticle={mediaAndArticle}
                            coachingVideos={coachingVideos}
                            jwtTokenDetails={jwtTokenDetails}
                            profileCompleteness={false}
                            isViewMode={true} isCoachProfile={false}
                            lastModifiedAt={lastModifiedAt}
                            profile={profile}></ProfileSummary>
                    </Paper>
                </Grid>

                <Grid size={{ xs: 12, sm: 7, md: 7 }} className={classes.gridItem}>
                    <Paper className={clsx(classes.profileDetails, 'custom-view')}>
                        {/* Other users profile */}
                        <ProfileDetails
                            userName={userName}
                            other={other}
                            additionalExperience={additionalExperience}
                            skillSet={skillSet}
                            educationDetail={educationDetail ? educationDetail : []}
                            coachingAndOtherJobExperience={coachingAndOtherJobExperience}
                            playingExperience={playingExperience}
                            getLeagueTextByValue={getLeagueTextByValue}
                            videoData={profileVideos}
                            coachingVideos={coachingVideos}
                        ></ProfileDetails>
                    </Paper>
                </Grid>

                <Grid size={{ xs: 12, sm: 2.5, md: 2.5 }} className={classes.gridItem}>
                    <Paper
                        className={clsx(classes.profileDetails, 'custom-view')}
                        sx={{
                            minHeight: '300px',
                            overflow: 'hidden',
                        }}
                    >
                        <Box
                            sx={{
                                backgroundColor: (theme) => theme.palette.mode === 'dark' ? "rgba(255,255,255,0.01)" : theme.palette.primary.main,
                                color: '#ffffff',
                                px: 2,
                                height: 72,
                                display: 'flex',
                                alignItems: 'center',
                                boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
                            }}
                        >
                            <Typography variant="subtitle2">Similar Profiles</Typography>
                        </Box>
                        <Box sx={{ p: 1 }}>
                            <SimilarProfilesList userName={userName} />
                        </Box>
                    </Paper>
                    <FeatureArticleNewsContent fullName={fullName} />
                </Grid>
            </Grid>
            {role == Role.Admin && (showApprove || showReject) &&
                <>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%', padding: '8px', gap: '8px' }}>
                        <Button onClick={handleEditProfileClick} variant="contained" color="primary">
                            Edit Profile
                        </Button>
                        <Button disabled={showReject && !showApprove} onClick={handleApproveClick} variant="contained" color="primary">
                            Approve
                        </Button>
                        <Button disabled={showApprove && !showReject} onClick={() => { setOpenRejectDialog(true); trackCustomEvents("EditEvent", { action: "On Hold" }) }} variant="contained" color="secondary">
                            On Hold
                        </Button>
                    </Box>
                </>}

            <RejectDialog
                open={openRejectDialog}
                onClose={() => setOpenRejectDialog(false)}
                onReject={(note, sendMail) => btnRejectClick(note, sendMail)}
            />
        </Box>
    );
}

export default CoachProfileView